import { GOAL_COLORS } from "../../utils/constants";
import { totalWeightage } from "../../utils/validators";

export default function WeightageMeter({ goals = [], compact = false }) {
  const total = totalWeightage(goals);
  const scale = Math.max(100, total);
  const diff = Math.round((100 - total) * 100) / 100;
  const state = total === 100 ? "complete" : total > 100 ? "over" : "under";
  const message =
    state === "complete"
      ? "Goal percentages total exactly 100%."
      : state === "over"
        ? `Over by ${Math.abs(diff)}%. Reduce a goal percentage to reach exactly 100%.`
        : goals.length
          ? `Add ${diff}% more to reach 100%.`
          : "Add goals until their goal percentages total 100%.";

  return (
    <div className={`weight-meter is-${state} ${compact ? "is-compact" : ""}`}>
      <div className="weight-meter-head">
        <span className="weight-meter-total">
          <strong>{total}%</strong>
          <span> of 100%</span>
        </span>
        <span className="weight-meter-msg" role="status">{message}</span>
      </div>
      <div className="weight-meter-track" aria-hidden="true">
        {goals.map((g, i) => (
          <span
            key={g.id || i}
            className="weight-meter-seg"
            style={{ width: `${(Number(g.weightage) / scale) * 100}%`, background: GOAL_COLORS[i % GOAL_COLORS.length] }}
            title={`${g.title}: ${g.weightage}%`}
          />
        ))}
        <span className="weight-meter-tick" style={{ left: `${(100 / scale) * 100}%` }} />
      </div>
      {!compact && goals.length > 0 && (
        <ul className="weight-meter-legend">
          {goals.map((g, i) => (
            <li key={g.id || i}>
              <span className="legend-swatch" style={{ background: GOAL_COLORS[i % GOAL_COLORS.length] }} />
              <span className="legend-name">{g.title}</span>
              <span className="legend-value">{g.weightage}%</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
